import * as React from "react";
import {ChangeEvent} from "react";
import MaskedInput from "react-text-mask";
import {ClickableProps} from "../../../../components/common/props/ClickableProps";
import {FocusableProps} from "../../../../components/common/props/FocusableProps";
import {EditableProps} from "../../../../components/common/props/EditableProps";
import {PlaceholderProps} from "../../../../components/common/props/PlaceholderProps";
import {DisableableProps} from "../../../../components/common/props/DisableableProps";
import {none, option, Option} from "ts-option";
import * as moment from "moment";
import DateUtils from "../../../../utils/DateUtils";
import {BlurableProps} from "../../../../components/common/props/BlurableProps";
import "./input.scss";

interface ComponentProps {
	/**
	 * Text input change callback.
	 */
	onChange: (value: Option<moment.Moment>) => void;
	/**
	 * Text input value.
	 */
	value?: Option<moment.Moment>;
	/**
	 * Optional array of regexp masks.
	 */
	mask?: Array<string | RegExp>;
	/**
	 * Date format corresponding to mask.
	 */
	dateFormat?: string;
}

interface State {
	/**
	 * String representation of the date.
	 */
	dateString: string;
}

type Props =
	ComponentProps
	& FocusableProps
	& ClickableProps
	& EditableProps
	& DisableableProps
	& PlaceholderProps
	& BlurableProps;

export default class MaskedDateInput extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {dateString: ""};
		this.onChange = this.onChange.bind(this);
	}

	public static defaultProps: Partial<Props> = {
		value: none,
		mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
		dateFormat: DateUtils.DMY_DATE_FORMAT
	};

	componentDidMount() {
		this.props.value.map(value => {
			if (value.isValid())
				this.setState({dateString: value.format(this.props.dateFormat)})
		});
	}

	componentWillReceiveProps(nextProps: Props) {
		nextProps.value.map(value => {
			if (value.isValid())
				this.setState({dateString: value.format(nextProps.dateFormat)})
		});
	}

	render() {
		return (
			<MaskedInput
				mask={this.props.mask}
				className="a-input"
				placeholder={this.props.dateFormat}
				guide={true}
				onClick={this.props.onClick}
				onChange={v => this.props.disabled ? {} : this.onChange(v)}
				value={this.state.dateString}
				onFocus={this.props.onFocus}
				onBlur={this.props.onBlur}
				disabled={this.props.disabled}
				readOnly={this.props.readonly}
			/>
		);
	}

	/**
	 * Store date in component state, if date is in valid format pass value.
	 * @param {React.ChangeEvent<HTMLInputElement>} evt
	 */
	onChange(evt: ChangeEvent<HTMLInputElement>) {
		this.setState({dateString: evt.target.value}, () => {
			if (DateUtils.DMY_DATE_REGEX.test(this.state.dateString)) {
				this.props.onChange(option(moment(this.state.dateString, DateUtils.DMY_DATE_FORMAT)))
			}
			else {
				this.props.onChange(none);
			}
		});
	}
}